import { useState } from 'react';

export const useLoginForm = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [userNameError, setUserNameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [isLoginFormValid, setIsLoginFormValid] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  return {
    userName,
    setUserName,
    password,
    setPassword,
    userNameError,
    setUserNameError,
    passwordError,
    setPasswordError,
    isLoginFormValid,
    setIsLoginFormValid,
    showPassword,
    setShowPassword
  };
};
